import { render, staticRenderFns } from "./TotalDetailSummaries.vue?vue&type=template&id=0a883016&lang=pug&"
import script from "./TotalDetailSummaries.vue?vue&type=script&lang=js&"
export * from "./TotalDetailSummaries.vue?vue&type=script&lang=js&"
import style0 from "./TotalDetailSummaries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TotalDetailSummaries.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListGroup } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
  VIcon,
  VLayout,
  VList,
  VListGroup,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VSubheader,
  VToolbar,
  VToolbarTitle,
})
